import React from "react";
import {renderRichText} from "gatsby-source-contentful/rich-text";

export default function PapersSection(props) {
    const content = props.content;
    return (
        <section key={content.id} className="papers-section" id={'papers'}>
            <div className="container">
                <div className="row mb-5 pb-5">
                    <div className="col-lg-6">
                        <h2>{content.title}</h2>
                    </div>
                    <div className="col-lg-5 offset-lg-1">
                        <div className={'subtitle'}>
                            {renderRichText(content.body)}
                        </div>
                    </div>
                </div>

                <div className="row">
                    { content.elements.map((element, i) => {
                        return (
                            <div className="col-md-6 pb-5" key={i}>
                                <h3>{element.title}</h3>
                                { element.subtitle && <p>{element.subtitle}</p>}
                                <ul>
                                    { element.elements.map((subElement, j) => {
                                        return (
                                            <li key={j}>
                                                <a href={subElement.file ? subElement.file.url : subElement.url}
                                                   target="_blank" rel={'noreferrer'}>
                                                    <span>Publication Year: {subElement.publicationYear}</span>
                                                    <p>
                                                        {subElement.title}
                                                        <i className="fas fa-arrow-right"/>
                                                    </p>
                                                </a>
                                            </li>
                                        );
                                    }) }
                                </ul>
                            </div>
                        );
                    }) }
                </div>
            </div>
        </section>
    )
}
